import { render } from "./VomsTable.vue?vue&type=template&id=218c2ce4&scoped=true"
import script from "./VomsTable.vue?vue&type=script&lang=js"
export * from "./VomsTable.vue?vue&type=script&lang=js"

import "./VomsTable.vue?vue&type=style&index=0&id=218c2ce4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-218c2ce4"]])

export default __exports__